import smartSolveApi from './instances/smartsolve';
import { RECENT_ITEMS_QUANTITY } from '../constants/SmartInsightConstants';

export const getRecentSmartInsightItems = async ({
  entityName,
  searchName,
  sortExpressionColumn,
}) => {
  try {
    const response = await smartSolveApi.post('/getsearchdata', {
      entityName,
      currentPageIndex: 0,
      pageSize: RECENT_ITEMS_QUANTITY,
      filter: [],
      sortExpression: sortExpressionColumn,
      referencedColumns: {},
      dynamicParamCollection: {},
      savedSearchName: searchName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getRecentSmartInsightItems failed: ${e}`);
  }
};
